<template>
  <div>
    <mobile-secondary-menu :menuItems="menuItems" :active="activeItem" :disable-button="itemDisabled" @change="changeValue" />
    <tabulated-controls :tabs="menuItems" v-model="activeItem" :disable-button="itemDisabled" class="hidden md:flex w-full" />
  </div>
</template>

<script>
import MobileSecondaryMenu from '@/components/MobileSecondaryMenu'
export default {
  name: 'ResponsiveSecondaryMenu',
  components: { MobileSecondaryMenu },
  model: {
    prop: 'active',
    event: 'change'
  },
  props: [
    'menuItems',
    'active',
    'itemDisabled'
  ],
  data () {
    return {
      activeItem: this.active
    }
  },
  watch: {
    active () {
      this.changeValue(this.active)
    },

    activeItem () {
      this.changeValue(this.activeItem)
    }
  },
  methods: {
    changeValue (id) {
      this.activeItem = id
      this.$emit('change', id)
    }
  }
}
</script>
